import "./AboutContentStyles.css"

import React from 'react'
import { Link } from "react-router-dom";

import React1 from "../assets/react1.jpg"
import Node1 from "../assets/node1.jpg"

const AboutContent = () => {
  return (
    <div className="about">
        <div className="left">
<h1>Who Am I ?</h1>
<p>I am a backend developer learning full stack development and waiting for a good company to take me !!</p>
<Link to="/contact">
    <button className="btn">Contact</button>
</Link>
        </div>

        <div className="right">
            <div className="img-container">
                <div className="img-stack top">
                    <img src={React1} className="img" alt="true" />
                </div>
                <div className="img-stack bottom">
                    <img src={Node1} className="img" alt="true" />
                </div>
            </div>

        </div>;
      
    </div>
  );
};

export default AboutContent
